import { useEffect } from 'react'
import { useAccount } from 'wagmi'
import useLogout from '@hooks/useLogout'
import useViewer from '@hooks/useViewer'

const useChangeAddressLogout = () => {
  const { viewer } = useViewer()
  const { address } = useAccount()
  const { logout } = useLogout()
  useEffect(() => {
    if (viewer?.walletAddress && address && viewer?.walletAddress != address?.toLowerCase()) {
      logout()
    }
  }, [address, viewer?.walletAddress])
}

export default useChangeAddressLogout
